<template>
  <div class="wrap">
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item >生产管理</el-breadcrumb-item>
        <el-breadcrumb-item >
        <span @click="goBack" class="cursor-pointer">报工</span>
      </el-breadcrumb-item>
        <el-breadcrumb-item >
          <span style="color:#000;font-weight:bold;cursor: pointer;" v-if="modelStatus == 'create'">创建报工</span>
          <span style="color:#000;font-weight:bold;cursor: pointer;" v-if="modelStatus != 'create'">编辑报工</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="top-large-margin">
          <div class="dialog-group-title" style="margin-bottom: 0;">基础信息</div>
      </div>
      <div class="white-background">
        <div  class="content">
            <el-form :model="form" label-width="108px" size="small" :rules="rules" ref="form">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="工单编号" prop="orderCode">
                          <!-- v-el-select-lazyloading="lazyloading" -->
                            <el-select v-model="form.orderCode" filterable placeholder="请选择" class="w300" @change="orderCodeChange"  >
                                <el-option
                                    v-for="item in orderNoOptions"
                                    :key="item.orderCode"
                                    :label="item.orderCode"
                                    :value="item.orderCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="工序名称" prop="taskId">
                            <el-select v-model="form.taskId" filterable placeholder="请选择" class="w300" @change="processChange">
                                <el-option
                                    v-for="item in operationOptions"
                                    :key="item._id"
                                    :label="item.processName"
                                    :value="item._id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="生产人员" prop="producer">
                            <!-- <el-input v-model="producer" placeholder="请填写" disabled class="w300"></el-input> -->

                            <el-select v-model="form.producer"   filterable placeholder="请选择"  class="w300" >
                                <el-option
                                    v-for="item in producerOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="产品编号">
                            <el-input v-model="form.productCode" placeholder="请填写" disabled class="w300"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="产品名称">
                            <el-input v-model="form.productName" placeholder="请填写" disabled class="w300"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="8">
                        <el-form-item label="工序状态">
                            <el-radio-group v-model="form.taskStatus" :disabled="!form.orderCode">
                                <el-radio label="未开始">未开始</el-radio>
                                <el-radio label="执行中">执行中</el-radio>
                                <el-radio label="已结束">已结束</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="8">
                        <el-form-item label="产品规格">
                            <el-input v-model="form.specs" placeholder="请填写" disabled class="w300"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="良品数">
                          <el-input-number v-model="form.goodNum" placeholder="请填写" controls-position="right"  size="small" :min="0" :max="9007199254740991"  class="w300" @input="goodNumChange" ></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="不良品数">
                          <el-input-number  v-model="form.nongoodNum" placeholder="请填写" controls-position="right"  size="small" :min="0" :max="9007199254740991" class="w300"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="不良品项">
                          <!-- <el-input v-model="nongoodId" placeholder="请填写" class="w300" disabled></el-input> -->
                          <el-select v-model="form.nongoodId" filterable clearable placeholder="请选择" class="w300"  @change="nongoodChange">
                                <el-option
                                    v-for="item in notGoodList"
                                    :key="item._id"
                                    :label="item.nongoodName"
                                    :value="item._id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                  <el-col :span="8">
                        <el-form-item label="报工数" prop="countNum">
                          <el-input-number v-model="form.countNum" controls-position="right"  size="small" :min="0" :max="9007199254740991" disabled class="w300"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="报工时长">
                            <el-input-number class="inputNumber" :disabled="form.taskStatus == '未开始' || form.taskStatus == '已结束'" v-model="form.durationHours" controls-position="right" @change="handleChange('h')" :min="0"></el-input-number>
                            小时
                            <el-input-number class="inputNumber" :disabled="form.taskStatus == '未开始' || form.taskStatus == '已结束'" v-model="form.durationMin" controls-position="right" @change="handleChange('m')" :min="0"></el-input-number>
                            分钟
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="8">
                        <el-form-item label="单位">
                          <el-input v-model="form.unit" placeholder="请填写" class="w300"  disabled></el-input>


                        </el-form-item>
                    </el-col> -->
                    <el-col :span="8">
                        <el-form-item label="时间">
                            <el-date-picker
                            @change="timeChange"
                              :disabled="form.taskStatus == '未开始' || form.taskStatus == '已结束'"
                              v-model="form.timeRange"
                              style="width: 300px;"
                              type="datetimerange"
                              format="yyyy-MM-dd HH:mm"
                              value-format="yyyy-MM-dd HH:mm"
                              range-separator="至"
                              start-placeholder="开始时间"
                              end-placeholder="结束时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>

                    <el-col :span="8">
                        <el-form-item label="标准效率">
                          <div v-if="form.standardEff">{{form.standardEff[0] + '/' + form.standardEff[1] + "时" }}</div>
                          <!-- <div v-if="form.standardEff">{{form.standardEff[0] + '/' + form.standardEff[1] + "时" + form.standardEff[2] +"分"}}</div> -->

                          <div v-if="!form.standardEff">未配置</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="实际效率" v-show="actualEff != 'Infinity'">
                          <span>{{calActualEff()}}</span>
                          <!-- 报工时长为0，无法计算效率 -->
                          <!-- <div>{{actualEff}}</div> -->
                          <!-- <el-input v-model="form.goodNum" class="num1" size="small" disabled style="width: 75px;"></el-input>
                            /
                            <el-input v-model="form.durationHours" class="num2" size="small" disabled style="width: 75px;"></el-input>
                            小时
                            <el-input v-model="form.durationMin" class="num2" size="small" disabled style="width: 75px;"></el-input>
                            分钟 -->
                        </el-form-item>
                        <el-form-item label="实际效率" v-show="actualEff == 'Infinity'">
                          <span>报工时长为0，无法计算效率</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="合格率">
                            <el-input v-model="form.achievement" placeholder="请填写" disabled class="w300"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>

                    <el-col :span="8">
                        <el-form-item label="工序进度">
                          <!-- <span v-if="modelStatus != 'edit'">{{(form.goodNum + (operation.goodNum?operation.goodNum:0)) +'/' +(operation.planNum?operation.planNum:'0')}}</span> -->
                            <!-- <el-input v-model="form.rateOfProgress" placeholder="请填写" disabled class="w300"></el-input> -->
                            <span>{{form.rateOfProgress}}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <FormItem :setList="setList" :form="form" :colSpan="8" :mode="modelStatus" v-if="showChild"></FormItem>

            </el-form>
        </div>
      </div>
      <div>
        <div class="dialog-group-title" style="margin-bottom: 0;">绩效信息</div>
        <div class="white-background">
            <div class="content">
                <el-form :model="performanceInfo" label-width="108px" size="small" :rules="rules" ref="form1">
                    <el-form-item label="计价方式">
                        <el-radio-group v-model="performanceInfo.countType" :disabled="form.taskStatus == '未开始' || form.taskStatus == '已结束'" @change="countTypeChange">
                            <el-radio label="计件">计件</el-radio>
                            <el-radio label="计时">计时</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="工资单价" prop="salaryUnit">
                        <el-input v-model="performanceInfo.salaryUnit" placeholder="请填写" disabled class="w300"></el-input>
                        <span>元</span>
                        <!-- <el-button type="primary" icon="el-icon-refresh" :disabled="form.taskStatus == '未开始' || form.taskStatus == '已结束'" style="margin-left: 12px;">刷新</el-button> -->
                    </el-form-item>
                    <el-form-item label="预计工资">
                        <el-input v-model="performanceInfo.estimateSalary" placeholder="请填写" disabled class="w300"></el-input>
                        <span>元</span>
                    </el-form-item>
                    <el-form-item label="审批状态">
                        <el-radio-group v-model="performanceInfo.approveStatus" @change="approveStatusChange" :disabled="form.taskStatus == '未开始' || form.taskStatus == '已结束'">
                            <el-radio label="已审批">已审批</el-radio>
                            <el-radio label="未审批">未审批</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="审批人">
                        <el-input v-model="performanceInfo.approver" placeholder="请填写" disabled class="w300"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="报工时间">
                        <el-date-picker
                          class="w300"
                          :disabled="form.taskStatus == '未开始' || form.taskStatus == '已结束'"
                            v-model="performanceInfo.operateTime"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            type="datetime"
                            placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item> -->
                </el-form>
            </div>
        </div>
        <div class="dialog-group-title">
            <div>自定义字段信息</div>
        </div>
        <!-- <div class="content">
            <el-form :model="diyForm" label-width="108px" size="small" :rules="rules">
                <el-form-item label="小计">
                    <el-input v-model="diyForm.subtotal" placeholder="请填写" class="w300"></el-input>
                </el-form-item>
                <el-form-item label="白班工时">
                    <el-input v-model="diyForm.dayTime" placeholder="请填写" class="w300"></el-input>
                </el-form-item>
                <el-form-item label="晚班工时">
                    <el-input v-model="diyForm.nightTime" placeholder="请填写" class="w300"></el-input>
                </el-form-item>
                <el-form-item label="报工类型">
                    <el-select v-model="diyForm.type" filterable placeholder="请选择" class="w300">
                            <el-option
                                v-for="item in typeOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                </el-form-item>
                <el-form-item label="不良品照片">
                    <el-upload
                        v-model="diyForm.imgUrl"
                        action=""
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="不良品备注">
                    <el-input v-model="diyForm.remark" placeholder="请填写" class="w300"></el-input>
                </el-form-item>
            </el-form>
        </div> -->
      </div>
      <div style="text-align: center;margin-top: 15px;">
          <el-button size="small" @click="cancel">取 消</el-button>
          <!-- <el-button size="small">继续报工</el-button> -->
          <el-button type="primary" size="small" @click="save">保 存</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { enterSave,orderGetAll,getAllTask,unitGetAll,orderGetList,getAll,getAllOrder} from '@/api/basicData';
import { queryAllUserList,queryProcessOne,querySalarySetOne} from '@/api/business';
import FormItem from "@/components/FormItem";
export default {
  props:['mode','userData','setList','editRow','modelStatus'],
  components:{
    FormItem
  },
  directives: {
    "el-select-lazyloading": {
      bind(el, binding) {
        let SELECT_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECT_DOM.addEventListener("scroll", function () {
          let condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      },
    },
  },
  watch:{
    'form.durationHours':{
      handler:function(){
        this.resetStandardCapacity()
      }
    },
    'form.durationMin':{
      handler:function(){
        this.resetStandardCapacity()
      }
    },
    'form.goodNum':{
      handler:function(){
        this.form.goodNum = this.form.goodNum?this.form.goodNum:0;
        this.form.nongoodNum = this.form.nongoodNum?this.form.nongoodNum:0;
        this.form.countNum = this.form.goodNum + this.form.nongoodNum;
        if(this.form.countNum > 0){

          this.form.achievement = ((this.form.goodNum / this.form.countNum) * 100).toFixed(2) + '%';
        }
        //this.resetStandardCapacity();
      }
    },
    'form.nongoodNum':{
      handler:function(){
        this.form.goodNum = this.form.goodNum?this.form.goodNum:0;
        this.form.nongoodNum = this.form.nongoodNum?this.form.nongoodNum:0;
        this.form.countNum = this.form.goodNum + this.form.nongoodNum;
        if(this.form.countNum > 0){

          this.form.achievement =((this.form.goodNum / this.form.countNum) * 100).toFixed(2) + '%';
        }

      }
    },


  },
  data() {
    var checkUnitPrice = (rulr,value,callback) =>{
      var copyValue = value + ''
      if(value<=0){
        callback('工资单价必须大于0')
      }else{
        var arr = copyValue.split('.')
        if(arr.length == 2){
          if(arr[0].length > 10){
            callback('整数位最多支持10位数字')
          }else{
            if(arr[1].length > 6){
              callback('小数点后最多保留6位数字')
            }else{
              callback()
            }
          }
        }else if(arr.length == 1){
          if(arr[0].length > 10){
            callback('整数位最多支持10位数字')
          }else{
            callback()
          }
        }else{

        }
      }
    }
    return {
      disabled:false,
      tabActive: 1,
      enterProduct:{},
      // 基础信息表单
      form: {
        taskStatus: '未开始',
        taskId:'',
        producer:'',
        productName:'',
        productId:'',
        productCode:'',
        specs:'',
        timeRange:[],
        goodNum:0,
        nongoodNum:0,
        nongoodId:'',
      },
      // 绩效信息表单
      performanceInfo: {
        countType: '计件',
        approveStatus: '已审批',
        approver:'',
        approveTime:''
      },
      // 自定义字段信息
      diyForm: {},
      rules: {
        orderCode:[{required:true,message:'请选择',trigger:['blur','change']}],
        taskId:[{required:true,message:'请选择',trigger:['blur','change']}],
        producer:[{required:true,message:'请选择',trigger:['blur','change']}],
        salaryUnit:[{required:true,message:'请去绩效工资配置工资单价',trigger:['blur','change']}],
        //countNum:[{validator:checkUnitPrice, trigger: ['blur','change']}] ,
      },
      orderNoOptions: [],  // 工单编号
      operationOptions: [], // 工序名称
      unitOption: [],   // 单位选择
      typeOption: [],   // 报工类型选择
      // 不良品照片预览
      dialogImageUrl: '',
      dialogVisible: false,
      producerOptions:[],
      orderList:[],
      listData: {
        limit: 8,
        page: 1,
      },
      notGoodList:[],
      notAllGoodList:[],
      hoursDo:'',
      producer:'',
      nongoodId:'',
      operation:{},
      standardCapacity2:'',
      standardCapacity3:'',
      achievement:'',
      actualEff:'',
      showChild:true
    }
  },
  created(){
    this.showChild = true;
    if(this.modelStatus == 'edit'){
      this.form = JSON.parse(JSON.stringify(this.editRow.baseInfo));
      this.enterProduct = JSON.parse(JSON.stringify(this.editRow.enterProduct));
      this.form.productCode = this.enterProduct.productCode
      this.form.productName = this.enterProduct.productName
      this.form.specs = this.enterProduct.specs
      this.form.productId = this.enterProduct._id
      this.$set(this.form,"producer",this.editRow.baseInfo.producer?this.editRow.baseInfo.producer.id:"");
      this.performanceInfo = JSON.parse(JSON.stringify(this.editRow.performanceInfo));
      if(!this.performanceInfo.approver){

        this.performanceInfo.approver = this.userData.name+'('+this.userData.account+')';
      }
      this.timeChange();
      this.getProcess(true);
    }else if(this.modelStatus == 'create'){
      this.form.timeRange[0] = moment().format('YYYY-MM-DD HH') + ':00'
      this.form.timeRange[1] = moment().format('YYYY-MM-DD HH') + ':00'
      this.performanceInfo.approver = this.userData.name+'('+this.userData.account+')';
    }
    //this.getAll()
    this.getList();
    //this.unitGetAll()
    //this.init();

  },
  methods: {
    approveStatusChange(val){
      console.log(val);
      if(val == '已审批'){
        this.performanceInfo.approver = this.userData.name+'('+this.userData.account+')';
      }else{
        this.performanceInfo.approver = '';
      }
    },
    calActualEff(){
      var res = "";
      var time = 0;
      if(this.form.durationHours && !isNaN(this.form.durationHours) ){
        time += this.form.durationHours;
      }
      if(this.form.durationMin &&  !isNaN(this.form.durationMin)){
        time += Number((this.form.durationMin / 60).toFixed(2));
      }
      if(this.form.goodNum && !isNaN(this.form.goodNum) && time > 0){
        res = (this.form.goodNum / time).toFixed(2) + '/1小时';
      }
      return res;
    },
    calPrice(type){
        this.$set(this.performanceInfo,'estimateSalary',0)
        if(type == '计件'){
          if(this.form.goodNum && !isNaN(this.form.goodNum)){
            var sum =   this.performanceInfo.salaryUnit * (parseFloat(this.form.goodNum));
            this.performanceInfo.estimateSalary = parseFloat(sum.toFixed(2));
          }
        }else{
          var sum = 0;
          if(this.form.durationHours && !isNaN(this.form.durationHours) ){

            sum = this.performanceInfo.salaryUnit * this.form.durationHours ;

          }
          if(this.form.durationMin &&  !isNaN(this.form.durationMin)){

            sum += this.performanceInfo.salaryUnit *(this.form.durationMin / 60)
          }
          this.performanceInfo.estimateSalary = parseFloat(sum.toFixed(2));
        }
    },
    nongoodChange(val){
      var item = this.notGoodList.filter(i=>i._id == val)[0];
      this.form.nongoodName = item.nongoodName;
    },
    countTypeChange(val){

      querySalarySetOne(this.userData.factoryId,this.operation.processCode,this.operation.productInfo.productCode,this.performanceInfo.countType).then(res1=>{
          if(res1.code == 200){
            if(res1.data){
              this.performanceInfo.countType = res1.data.countBy;
              this.performanceInfo.salaryUnit = res1.data.unitPrice;
              this.form.standardEff = res1.data.standardCapacity;
              this.performanceInfo = JSON.parse(JSON.stringify(this.performanceInfo));
              }else{
                //this.performanceInfo.countType = '';
                this.performanceInfo.salaryUnit = 0
                this.form.standardEff = '';
                //this.performanceInfo = {};
            }
            this.calPrice(val);
          }else{
            this.$message.error("工资单价查询失败，请联系技术人员");
          }
        });
    },
    processChange(val){
      this.notGoodList = []
      this.operation = this.operationOptions.filter(item=>item._id == val)[0];
      this.form.rateOfProgress = this.operation.rateOfProgress;
      if(this.operation.nongoodIdList){

        for(let i = 0;i<this.operation.nongoodIdList.length;i++){
          let item = {
            _id:this.operation.nongoodIdList[i]['_id'],
            nongoodName:this.operation.nongoodIdList[i]['nongoodName'],
          }
          this.notGoodList.push(item);
        }
      }
      this.producerOptions = [];
      if(this.operation.allocateList){

        for(let i = 0;i<this.operation.allocateList.length;i++){
          this.producerOptions.push({
            label:this.operation.allocateList[i]['name'] + '('+this.operation.allocateList[i]['account']+')',
            value:this.operation.allocateList[i]['_id'],
          });
        }
      }
      querySalarySetOne(this.userData.factoryId,this.operation.processCode,this.operation.productInfo.productCode,this.performanceInfo.countType).then(res1=>{
          if(res1.code == 200){
            if(res1.data){
              this.performanceInfo.countType = res1.data.countBy;
              this.performanceInfo.salaryUnit = res1.data.unitPrice;
              this.form.standardEff = res1.data.standardCapacity;
              this.performanceInfo = JSON.parse(JSON.stringify(this.performanceInfo));
              }else{
                this.performanceInfo.countType = '';
                this.performanceInfo.salaryUnit = 0
                this.form.standardEff = '';
                this.performanceInfo = {};
            }
          }
        });

      // queryProcessOne(this.userData.factoryId,this.operation.processCode).then(res=>{
      //   if(res.code == 200){

      //     this.notGoodList = [];
      //     if(res.data){


      //     }



      //   }
      // });


    },
    resetStandardCapacity(){

      if(this.form.durationHours +  this.form.durationMin != 0){
        this.actualEff = this.form.goodNum/(this.form.durationHours +  this.form.durationMin/60);

        this.actualEff = (this.actualEff == window.Infinity)?'Infinity':this.actualEff;
        if(this.actualEff && this.actualEff != 'Infinity'){
          this.actualEff = this.actualEff.toFixed(2)
          // this.standardCapacity2 = this.form.durationHours;
          // this.standardCapacity3 = this.form.durationMin;
        }
      }
    },
    timediff(begin_time, end_time){
      //年月日时分秒转换为时间戳
      let beginTime = (new Date(begin_time).getTime()) / 1000;
      let endTime = (new Date(end_time).getTime()) / 1000;
      var starttime = ''
      var endtime = ''
      if (beginTime < endTime) {
        starttime = beginTime;
        endtime = endTime;
      } else {
        starttime = endTime;
        endtime = beginTime;
      }
      //计算天数
      var timediff = endtime - starttime;
      var days = parseInt(timediff / 86400);
      //计算小时数
      var remain = timediff % 86400;
      var hours = parseInt(remain / 3600);
      //计算分钟数
      var remain = remain % 3600;
      var mins = parseInt(remain / 60);
      return {
        hours: hours + days*24,
        mins: mins,
      }
    },
    goodNumChange(){
      this.calPrice(this.performanceInfo.countType);
      if(this.form.timeRange && this.form.timeRange.length!=0){
        // var date = this.timediff(this.form.timeRange[0], this.form.timeRange[1])
      }
    },
    timeChange(){
      console.log('form',this.form)
      if(this.form.timeRange && this.form.timeRange.length!=0){
        var date = this.timediff(this.form.timeRange[0], this.form.timeRange[1])
        this.form.durationHours = date.hours
        this.form.durationMin = date.mins
        this.calPrice(this.performanceInfo.countType);
      }
    },
    async init(){
      // let res = await queryAllUserList(this.userData.factoryId);
      // if(res['code'] == 200){
      //     this.producerOptions = res.data.map(function(item){
      //       return {
      //         label:item.name,
      //         value:item._id
      //       }
      //     })
      // }
    },
    // 查询所有单位
    unitGetAll(){
      unitGetAll(this.userData.factoryId).then(res => {
        if(res.code == 200){
          this.unitOption = res.data;
        }
      })
    },
    // 查询所有不良品项
    getAll(){
      getAll(this.userData.factoryId).then(res => {
        if(res.code == 200){
          this.notAllGoodList = res.data;
        }
      })
    },
    orderCodeChange(val){
      var data = this.orderNoOptions.filter(item=>item.orderCode == val)[0];
      //var temp = JSON.parse(JSON.stringify(data));
      this.form.unit = data.productInfo.unit;
      this.getProcess();
    },
    // 查询工单下的所有工序
    getProcess(type){
      this.producerOptions = [];
      if(!type){
        this.form.producer = "";
        this.form.nongoodId = "";
      }
      getAllTask(this.userData.factoryId,this.form.orderCode).then(res => {
        if(res.code == 200){
          if(res.data && res.data.length > 0){
            this.operationOptions = res.data;
            if(!this.operationOptions || this.operationOptions.length == 0) return;
            if(!type){

              this.form.taskId = this.operationOptions[0]._id;
              // this.enterProduct = this.operationOptions[0].productInfo;
              this.form.productName =  this.operationOptions[0].productInfo.productName;
              this.form.productCode =  this.operationOptions[0].productInfo.productCode;
              this.form.specs =  this.operationOptions[0].productInfo.specs;
              this.form.productId =  this.operationOptions[0].productInfo._id;
            }



            // if(this.operationOptions[0].allocateList){

            //   for(let i = 0;i<this.operationOptions[0].allocateList.length;i++){
            //     this.producerOptions.push({
            //       label:this.operationOptions[0].allocateList[i]['name'] + '('+this.operationOptions[0].allocateList[i]['account']+')',
            //       value:this.operationOptions[0].allocateList[i]['_id'],
            //     });
            //   }
            // }

            this.processChange(this.form.taskId);

          }
        }
        this.form.taskStatus = '执行中'
      })
    },
    handleChange(val){
      if(this.form.timeRange && this.form.timeRange.length!=0){
        var tem = 0
        if(this.form.durationHours){
          tem += this.form.durationHours*3600*1000
        }
        if(this.form.durationMin){
          tem += this.form.durationMin*60*1000
        }
        var newTem = new Date(Date.parse(this.form.timeRange[1])).getTime() - tem
        this.form.timeRange[0] = moment(newTem).format('YYYY-MM-DD HH:mm')
        this.$set(this.form.timeRange,[0],moment(newTem).format('YYYY-MM-DD HH:mm'))

        this.calPrice(this.performanceInfo.countType);
      }
    },
    // 上传照片
    handleRemove(file, fileList) {
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    save(){
      var _this = this
      this.$refs.form.validate((valid) => {
         if (valid) {
          this.$refs.form1.validate((valid2) => {
            if(valid2){
              var data = {}
              data.baseInfo = JSON.parse(JSON.stringify(_this.form));
              let temp = _this.producerOptions.filter(item=>item.value == _this.form.producer);
              // data.baseInfo.producer.push({
              //   id:temp.value,
              //   name:temp.label
              // });
              if(temp && temp.length!=0){
                data.baseInfo.producer = {
                  id:temp[0].value,
                  name:temp[0].label
                };
              }
                data.performanceInfo = JSON.parse(JSON.stringify(_this.performanceInfo));
                data.factoryId = _this.userData.factoryId

                data.updater = _this.userData.name + '(' + _this.userData.account+')'
                data.performanceInfo.approveTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

                temp = _this.operationOptions.filter(function(item){
                  return item._id == _this.form.taskId
                })
               data.baseInfo.processName = temp[0].processName
               data.baseInfo.processCode = temp[0].processCode
               data.baseInfo.processId = temp[0].processInfo._id
               temp = _this.orderNoOptions.filter(function(item){
                return item.orderCode == _this.form.orderCode
              })
              data.baseInfo.orderId = temp[0]._id
              data.baseInfo.productId = _this.form.productId
               if(_this.modelStatus == 'edit'){
                 data._id = _this.editRow._id
                 data.updateFlag = _this.editRow.updateFlag

               }else{
                  data.creater =_this.userData.name + '(' + _this.userData.account+')'
               }
               if(data.timeRange && data.timeRange.length!=0){
                 data.startTime = data.timeRange[0]
                 data.endTime = data.timeRange[1]
               }
               if(data.baseInfo.nongoodNum){
                  data.baseInfo.nongoodNum = Number(data.baseInfo.nongoodNum)
                }
                if(data.baseInfo.goodNum){
                  data.baseInfo.goodNum = Number(data.baseInfo.goodNum)
                }
               data.baseInfo.countDuration = _this.form.durationHours + "小时" + _this.form.durationMin + "分钟";
               //_this.calHours2(_this.form.durationHours,_this.form.durationMin);
              //  data.baseInfo.actualEff = _this.form.goodNum + "/" + _this.form.durationHours + "小时" + _this.form.durationMin + "分钟";
               data.baseInfo.actualEff = _this.calActualEff();
              //  _this.calHours2(_this.form.durationHours,_this.form.durationMin) > 0 ?
              //  Math.round((_this.form.goodNum / (_this.calHours2(_this.form.durationHours,_this.form.durationMin)))*100) /100 : 0;
               data.baseInfo.rateOfProgress = (_this.form.goodNum + (this.operation.goodNum?this.operation.goodNum:0)) + "/" + this.operation.planNum;
              //  this.operation.planNum > 0?
              //  Math.round( ((_this.form.goodNum + (this.operation.goodNum?this.operation.goodNum:0)) / this.operation.planNum ) * 100) /100:0
               data.baseInfo.standardEff = _this.form.standardEff ? (_this.form.standardEff[0] + "/" +
               _this.form.standardEff[1] + "时"):"";
              //  (_this.form.standardEff && _this.calHours2(_this.form.standardEff[1],_this.form.standardEff[2]) > 0) ?
              //  Math.round((_this.form.standardEff[0] / (_this.calHours2(_this.form.standardEff[1],_this.form.standardEff[2]))) * 100) /100 : 0
               delete data.timeRange
               enterSave(data).then(res => {
                 if(res.code == 200){
                  _this.$message.success('保存成功')
                  _this.showChild = false;
                  _this.$emit('done',{type:'save'})
                 }else{
                  _this.$message.error(res.msg)
                 }
               }).catch(err => {
                _this.$message.error(err)
               })
            }
          })
         }
     })
    },
    calHours2(hours,minute){
      var _h = Math.round(minute * 100) / 100;
      return hours + _h;
    },
     // 下拉框懒加载
    lazyloading() {
      this.listData.page++;
      this.getList();
    },
    getList(){
       let data = {
         condition: {
           factoryId: this.userData.factoryId,
           orderStatus: '执行中',
         }
       }
        //   currentPage: this.listData.page,
        //   pageSize: this.listData.limit
        // }
        // orderGetList(data).then(res => {
        //   if(res.code == 200){
        //     this.orderNoOptions = [...this.orderNoOptions, ...res.data.list];
        //   }
        // })

        // let data={
        //   condition:{
        //     factoryId: this.userData.factoryId,
        //   }
        // }
        getAllOrder(data).then(res => {
          if(res.code == 200){
            this.orderNoOptions = [...this.orderNoOptions, ...res.data];
            this.orderNoOptions =this.orderNoOptions ? this.orderNoOptions
            .filter(item=>item.orderStatus != '已结束' && item.orderStatus != '已取消' && item.orderStatus != '未开始'):[];
          }
        })
    },
    /**
     * 返回上一级
     */
    goBack(){
      this.showChild = false;
      this.$emit("goBack");
    },
    cancel(){
      this.showChild = false;
      this.$emit('done',{type:'cancel'})
    },
  },
}
</script>
<style scoped>
.wrap {
    color: #000;
    background: #fff;
    font-size: 16px;
    width: 100%;
}
.form-title{
    height: 30px;
    z-index: inherit;
}
.content {
    width: 100%;
    padding-right: 40%;
}
.wrap >>> .w300{
    width: 300px!important;
}

</style>



// WEBPACK FOOTER //
// src/views/workReport/CreateReport.vue